import {
  PickingProduct,
  Picking,
  PickingGrid
} from '../../interfaces/Picking/Picking'

export function MapToPickingGridArray(arr: Picking[]): PickingGrid[] {
  return arr.map((item: Picking) => MapToPickingGrid(item))
}

export function MapToPickingGrid(item: Picking): PickingGrid {
  return {
    id: item.id,
    sku: item.sku,
    ean13: item.ean13,
    name: item.name,
    ERPCode: item.ERPCode,
    realHeight: item.realHeight,
    realWidth: item.realWidth,
    realLength: item.realLength,
    realWeight: item.realWeight,
    shippingHeight: item.shippingHeight,
    shippingWidth: item.shippingWidth,
    shippingLength: item.shippingLength,
    shippingWeight: item.shippingWeight,
    active: item.active
  }
}

export function MapToPickingProduct(
  item: Picking | undefined
): PickingProduct | undefined {
  return item === undefined
    ? undefined
    : {
        id: item.id,
        sku: item.sku,
        ean13: item.ean13,
        name: item.name,
        ERPCode: item.ERPCode,
        realHeight: item.realHeight ? item.realHeight : 0,
        realWidth: item.realWidth ? item.realWidth : 0,
        realLength: item.realLength ? item.realLength : 0,
        realWeight: item.realWeight ? item.realWeight : 0,
        shippingHeight: item.shippingHeight ? item.shippingHeight : 0,
        shippingWidth: item.shippingWidth ? item.shippingWidth : 0,
        shippingLength: item.shippingLength ? item.shippingLength : 0,
        shippingWeight: item.shippingWeight ? item.shippingWeight : 0,
        active: item.active
      }
}

export function dateToString(date: Date | null): string {
  if (!date) {
    return 'indefinido'
  }

  const d: Date = new Date(date)
  return `${padStr(d.getDate())}-${padStr(1 + d.getMonth())}-${padStr(
    d.getFullYear()
  )}`
}

export function padStr(i: number) {
  return i < 10 ? '0' + i : '' + i
}

export function intIfNumber(
  event: React.ChangeEvent<HTMLInputElement>,
  numericFields: string[]
) {
  return numericFields.includes(event.target.name)
    ? parseInt(event.target.value)
    : event.target.value
}
